import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { removeSpace } from "@edp-utils/remove-space.util";

@Component({
    selector: "no-associated-contact",
    templateUrl: "./no-associated-contact.component.html",
    styleUrls: ["./no-associated-contact.component.scss"],
})
export class NoAssociatedContactComponent {
    public tel: string;
    public hrefTel: string;

    constructor(
        public steperService: EdpSteperService,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private readonly translateService: TranslateService
    ) {
        this.tel =  this.translateService.instant("pt.edp.edponline.no.associated.contact.telephone");
        this.hrefTel = `tel:${removeSpace(this.tel)}`;
    }

    public close() {
        this.steperService.setActiveStep(1);
        this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.PERSONAL);
    }
}